<template lang="pug">
  d-input-base(
    component="v-text-field"
    v-bind="extendAttrs"
    v-on="$listeners"
  )
    template(
      v-for="(_, name) in $scopedSlots"
      v-slot:[name]="data"
    )
      slot(:name="name" v-bind="data")
    template(
      v-for="(_, name) in $slots"
      :slot="name"
    )
      slot(:name="name")
</template>

<script>
import DInputBase from './DInputBase.vue';
import { VTextField } from 'vuetify/lib';

export default {
  components:  {
    DInputBase,
    VTextField,
  },
  props: {
    componentClass: { type: String, default: '' },
  },
  computed: {
    extendAttrs() {
      return {
        placeholder: 'Начните вводить...',
        componentClass: [
          'dv-text-field',
          this.componentClass,
        ].filter(Boolean).join(' '),
        height: 48,
        ...this.$attrs,
      };
    },
  },
};
</script>

<style lang="scss" scoped></style>
